import React from 'react';
import { Typography, Stack } from '@mui/material';
import { AccessTimeFilled, Cancel, CheckCircle } from '@mui/icons-material';
import { TCandidate } from './types';
import StyledModal from '../Components/GenericModal/StyledModal';
import { sharedClasses } from '../Components/CustomUIElements/sharedClasses';
import ModalFooterButtons from '../Components/GenericModal/ModalFooterButtons';

interface CandidateDetailsDialogProps {
  open: boolean;
  onClose: () => void;
  candidate: TCandidate | null;
  conditions: Array<{ id?: number; content: string; weight: number; short_label?: string }>;
}

const CandidateDetailsDialog: React.FC<CandidateDetailsDialogProps> = ({ open, onClose, candidate, conditions }) => {
  if (!candidate) return null;

  const matchingIndicator = (
    candidate: TCandidate,
    condition: { id?: number; content: string; weight: number; short_label?: string }
  ) => {
    if (!candidate.assessed) {
      return <AccessTimeFilled color="disabled" />;
    }

    if (candidate.matched_condition_ids.includes(condition.id ?? 0)) {
      return <CheckCircle color="success" />;
    }

    return <Cancel color="error" />;
  };

  return (
    <StyledModal
      isOpen={open}
      handleClose={onClose}
      styleOverrides={{
        maxWidth: '1000px',
        maxHeight: '700px'
      }}
      label="candidate-details-dialog"
      modalTitle="Candidate Details"
      subHeaderStyling={false}
    >
      <Stack sx={{ ...sharedClasses.mainModalContent, height: '100%' }} spacing={2}>
        <Stack>
          <Typography variant="body1">
            Name: {candidate.firstname} {candidate.lastname}
          </Typography>
          <Typography variant="body1">Email: {candidate.email}</Typography>
        </Stack>
        <Typography variant="h6">Suitability Analysis</Typography>
        <Typography variant="body1">{candidate.suitability_comment}</Typography>

        <Stack direction="row">
          <Typography variant="h6">Matching:</Typography>
          <Typography variant="h6" style={{ color: candidate.matching_percent_color }}>
            {candidate.matching_percent}%
          </Typography>
        </Stack>
        {conditions.map((condition, index) => (
          <Stack key={index} sx={{ mb: 2 }}>
            <Stack direction="row">
              <Stack>{matchingIndicator(candidate, condition)}</Stack>
              <Stack>
                {condition.content} ({condition.weight})
              </Stack>
            </Stack>
          </Stack>
        ))}
      </Stack>
      <ModalFooterButtons
        primaryButtonText="Close"
        primaryButtonCallback={onClose}
        primaryButtonID="close-candidate-details"
      />
    </StyledModal>
  );
};

export default CandidateDetailsDialog; 
